// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prev-chat-container {
  display: flex;
  flex-direction: column;
}

.close-button {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 5px;
}

.custom-cursor-pointer {
  cursor: pointer;
}

.panel-hide {
  font-size: 1em;
  margin: auto 0 !important;
  display: flex;
  align-items: center;
}

.new-chat-label {
  font-size: 1em;
  font-weight: bold;
  margin: auto 0 !important;
  display: flex;
  align-items: center;
}

.new-chat-button {
  font-size: 1.5em;
  font-weight: bold;
}

.list-group-container {
  background-color: rgba(1, 72, 134, 0.5) !important;
}

.accordion-label {
  transition: background-color 0.3s;
}

.accordion-content {
  display: flex !important;
  flex-direction: row;
}
.accordion-content .chat-name {
  width: 100%;
  overflow: hidden;
  transition: max-height 0.3s;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.accordion-content .delete-icon {
  cursor: pointer;
  display: none;
  opacity: 0.2;
  transition: opacity 0.3s;
}
.accordion-content .delete-icon:hover {
  opacity: 1;
}
.accordion-content:hover .delete-icon {
  display: block;
  opacity: 1;
}
.accordion-content:hover .chat-name {
  width: 90%;
}

.chat-list-group {
  margin-bottom: 10px;
  overflow-y: auto;
}

.selected-chat {
  background-color: #a2c7e4 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/chat-history/ChatHistory.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;AADJ;;AAIA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AADJ;;AAIA;EACI,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,kDAAA;AADJ;;AAIA;EAEI,iCAAA;AAFJ;;AAKA;EASI,wBAAA;EACA,mBAAA;AAVJ;AACI;EACI,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;AACR;AAKI;EAEI,eAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;AAJR;AAMQ;EACI,UAAA;AAJZ;AAQI;EACI,cAAA;EACA,UAAA;AANR;AASI;EACI,UAAA;AAPR;;AAWA;EACI,mBAAA;EACA,gBAAA;AARJ;;AAWA;EACI,oCAAA;AARJ","sourcesContent":["$animation-duration: 0.3s;\n\n.prev-chat-container {\n    display: flex;\n    flex-direction: column;\n}\n\n.close-button {\n    display: flex;\n    justify-content: flex-end;\n    padding-bottom: 5px;\n}\n\n.custom-cursor-pointer {\n    cursor: pointer;\n}\n\n.panel-hide {\n    font-size: 1em;\n    margin: auto 0 !important;\n    display: flex;\n    align-items: center;\n}\n\n.new-chat-label {\n    font-size: 1em;\n    font-weight: bold;\n    margin: auto 0 !important;\n    display: flex;\n    align-items: center;\n}\n\n.new-chat-button {\n    font-size: 1.5em;\n    font-weight: bold;\n}\n\n.list-group-container {\n    background-color: rgba(1, 72, 134, 0.5) !important\n}\n\n.accordion-label {\n\n    transition: background-color $animation-duration;\n}\n\n.accordion-content {\n    .chat-name {\n        width: 100%;\n        overflow: hidden;\n        transition: max-height $animation-duration;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n\n    display: flex !important;\n    flex-direction: row;\n\n    .delete-icon {\n        // float: left;\n        cursor: pointer;\n        display: none;\n        opacity: 0.2;\n        transition: opacity 0.3s;\n\n        &:hover {\n            opacity: 1;\n        }\n    }\n\n    &:hover .delete-icon {\n        display: block;\n        opacity: 1;\n    }\n\n    &:hover .chat-name {\n        width: 90%;\n    }\n}\n\n.chat-list-group {\n    margin-bottom: 10px;\n    overflow-y: auto;\n}\n\n.selected-chat {\n    background-color: #a2c7e4 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
